import { render, staticRenderFns } from "./Benefits.vue?vue&type=template&id=562a618e&scoped=true"
import script from "./Benefits.vue?vue&type=script&setup=true&lang=ts"
export * from "./Benefits.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Benefits.vue?vue&type=style&index=0&id=562a618e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562a618e",
  null
  
)

export default component.exports